import { render, staticRenderFns } from "./StoreProductTabReadOnlyOLD.vue?vue&type=template&id=b66b57fa&"
import script from "./StoreProductTabReadOnlyOLD.vue?vue&type=script&lang=js&"
export * from "./StoreProductTabReadOnlyOLD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports